var exports = {
  "Fq": "detailsHeading__TviXZu",
  "Gv": "backButton__PFfzDa",
  "GD": "backButtonInner__KZYr4P",
  "j2": "backIcon__hkVJKL",
  "$P": "backText__sog9YL",
  "b": "closeButton__28H-EG",
  "oT": "definitionHeaderWrapper__ygxcc6",
  "zp": "spinnerWrapper__TfrwHk",
  "bV": "sectionHeader__rMlHN1",
  "SF": "sectionHeading__FBBNgU",
  "ii": "sectionSearchType__sWVPOF",
  "br": "navButtonWrapper__cpvk6N",
  "FD": "navButtonPrev__uKHQCz",
  "Te": "navButtonNext__gdyjKi",
  "p$": "emptyState__iogNo7",
  "qr": "footer__H-Mm21",
  "dO": "showMoreButton__zuu-Jw",
  "JU": "searchButton__I9I96K",
  "r1": "definitionHeader__apist2",
  "su": "symbolIndicatorRow__G7874A",
  "Rz": "symbolTruncate__u_7n07",
  "CB": "symbolSegment__rOkmav",
  "YC": "symbolSegmentClickable__hsIRoS",
};

module.exports = exports;
